<mat-form-field [appearance]="appearance">
    <mat-label>{{ placeholder }}</mat-label>

    <input
        readonly
        matInput
        type="text"
        [disabled]="readOnly"
        [min]="min"
        [ngxTimepicker]="timepicker"
        [format]="24"
        [formControl]="control"
        [name]="control.name"
        [errorStateMatcher]="matcher"
        [max]="max"
    />
    <mat-icon matSuffix>access_time</mat-icon>

    <ngx-material-timepicker
        #timepicker
        [ngxMaterialTimepickerTheme]="adaptTheme() ? darkTheme : lightTheme"
        [cancelBtnTmpl]="cancelBtn"
        [confirmBtnTmpl]="confirmBtn"
    ></ngx-material-timepicker>

    <!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
    <ng-template
        ngFor
        let-key
        [ngForOf]="control.validationKeys"
        ngProjectAs="mat-error"
    >
        <mat-error *ngIf="control.hasError(key)">
            {{ control.getErrorMessage(key) }}
        </mat-error>
    </ng-template>
</mat-form-field>

<ng-template #cancelBtn>
    <button mat-button color="primary">ANNULER</button>
</ng-template>
<ng-template #confirmBtn>
    <button mat-button color="primary">OK</button>
</ng-template>
